import { render, staticRenderFns } from "./Merch.vue?vue&type=template&id=2b58284d&scoped=true&"
import script from "./Merch.vue?vue&type=script&lang=js&"
export * from "./Merch.vue?vue&type=script&lang=js&"
import style0 from "./Merch.vue?vue&type=style&index=0&id=2b58284d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b58284d",
  null
  
)

export default component.exports